import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
import { Workbook } from "exceljs";
import { roles } from "../../../../common/constants";
/**
 *
 * @param {any[]} topEmployees
 * @returns {Workbook}
 */
export const exportExcel = async (
  topEmployees,
  selectedStore,
  startDate,
  endDate
) => {
  topEmployees.forEach((employee, index) => (employee.order = index + 1));

  const json = excelHelper.jsonToJson(
    [topEmployees],
    [
      {
        name: "TOP EMPLEADOS",
        props: [
          {
            inValue: "order",
            outValue: "ORDEN",
          },
          {
            inValue: "name",
            outValue: "NOMBRE",
          },
          {
            inValue: "lastname",
            outValue: "APELLIDO",
          },
          {
            inValue: "totalSold",
            outValue: "MONTO RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;

  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-mejores-empleados_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-mejores-empleados_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardSellsTopEmployee/excel.js